var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mHead"
  }, [_c('div', {
    staticClass: "mHead-main"
  }, [_c('div', {
    staticClass: "mHead-avatar",
    on: {
      "click": function ($event) {
        return _vm.onSkip('/center');
      }
    }
  }, [_c('div', {
    staticClass: "mHead-avatar-img"
  }, [_c('div', {
    staticClass: "head",
    style: {
      background: `url(${require(`@images/avatar/head/${_vm.gameProgress.currentLevel >= _vm.botImgLimit ? _vm.botImgLimit : _vm.gameProgress.currentLevel}.png`)}) center/auto 100% no-repeat`
    }
  })]), _c('div', {
    staticClass: "mHead-avatar-level"
  }, [_vm._v("Lv." + _vm._s(_vm.gameProgress.currentLevel) + " "), _c('div', {
    staticClass: "mHead-avatar__did"
  }, [_vm._v("DID: " + _vm._s(_vm.didInfo?.completion?.completion_rate * 100) + "%")])])]), _c('div', {
    staticClass: "mHead-btns"
  }, [_c('div', {
    staticClass: "mHead-btn",
    on: {
      "click": function ($event) {
        return _vm.onSkip('/pass');
      }
    }
  }, [_c('img', {
    staticClass: "pass",
    attrs: {
      "src": require('@images/PASS.png'),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.airdrop_ticket, 2, true, true)))])]), _c('div', {
    staticClass: "mHead-btn",
    on: {
      "click": function ($event) {
        return _vm.onSkip('/walletDetail?cid=ton&id=1');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-usdt.png'),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.fmt_pre(_vm.balanceInfo.usdt.balance, 3, true, true)) + " ")])]), _c('div', {
    staticClass: "btn-more wow zoomIn",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require(`@images/icon/icon-menu.png`),
      "alt": ""
    },
    on: {
      "click": () => _vm.popMenuShow = true
    }
  }), _vm.popMenuShow ? _c('div', {
    staticClass: "pop-more",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "shadow",
    on: {
      "click": () => _vm.popMenuShow = false
    }
  }), _c('div', {
    staticClass: "pop-more-main"
  }, [_c('div', {
    staticClass: "pop-more-item"
  }, [_c('div', {
    directives: [{
      name: "tip",
      rawName: "v-tip.bottom.click",
      value: `Withdrawals will be available soon`,
      expression: "`Withdrawals will be available soon`",
      modifiers: {
        "bottom": true,
        "click": true
      }
    }],
    staticClass: "mHead-btn"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star-fill.png'),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.balanceInfo.stars.balance, 2, true, false)))])])]), _c('div', {
    staticClass: "pop-more-item"
  }, [_c('div', {
    staticClass: "mHead-btn",
    on: {
      "click": function ($event) {
        return _vm.onSkip('/walletDetail?cid=ton&id=2');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-ton.png'),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.balanceInfo.ton.balance, 2, true, false)))])])])])]) : _vm._e()])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };